import { connect } from 'react-redux';
import React, { PropTypes } from 'react';
import { updateData } from '../actions/form';
import RadioOptionWithComment from 'common/components/RadioOptionWithComment';
import MultiReferenceCheckbox from 'common/components/MultiReferenceCheckbox';
import RadioOption from 'common/components/RadioOption';
import { Segment } from 'semantic-ui-react';
import Analysis from './Analysis';

export class StateOfPlay extends React.Component {
  render() {
    return (
      <div>
        <MultiReferenceCheckbox
          label="Types de sol"
          values={this.props.groundTypes}
          otherValue={this.props.groundTypeOther}
          references={this.props.groundTypeRefs}
          onChangeValues={this.props.onGroundTypesChange}
          onChangeOther={this.props.onGroundTypeOtherChange}
          withOther
          readOnly={this.props.readOnly}
        />

        <RadioOptionWithComment
          name="moistureTrace"
          value={this.props.moistureTrace}
          valueOther={this.props.moistureTraceComment}
          title="Traces d'humidité dans le bâti"
          onChange={this.props.onMoistureTraceChange}
          onChangeOther={this.props.onMoistureTraceCommentChange}
          readOnly={this.props.readOnly}
        />

        <RadioOptionWithComment
          name="treatmentBefore"
          value={this.props.termiteTreatmentBefore}
          valueOther={this.props.termiteTreatmentBeforeComment}
          title="Traitement termite effectué dans le passé"
          onChange={this.props.onTermiteTreatmentBeforeChange}
          onChangeOther={this.props.onTermiteTreatmentBeforeCommentChange}
          readOnly={this.props.readOnly}
        />

        <RadioOptionWithComment
          name="termiteInNeighbourhood"
          value={this.props.termiteInNeighbourhood}
          valueOther={this.props.termiteInNeighbourhoodComment}
          title="Problème de termite dans le voisinage"
          onChange={this.props.onTermiteInNeighbourhoodChange}
          onChangeOther={this.props.onTermiteInNeighbourhoodCommentChange}
          readOnly={this.props.readOnly}
        />

        <Analysis readOnly={this.props.readOnly} />

        <RadioOption
          name="accessible"
          value={this.props.accessible}
          title="Accès à la charpente"
          onChange={this.props.onAccessibleChange}
          readOnly={this.props.readOnly}
        />

        <Segment style={{ backgroundColor: '#f9fafb' }}>
          <RadioOptionWithComment
            name="damagesObserved"
            value={this.props.damagesObserved}
            valueOther={this.props.damagesObservedComment}
            title="Dégâts constatés"
            onChange={this.props.onDamagesObservedChange}
            onChangeOther={this.props.onDamagesObservedCommentChange}
            readOnly={this.props.readOnly}
          />
          <RadioOptionWithComment
            name="termitesObserved"
            value={this.props.termitesObserved}
            valueOther={this.props.termitesObservedComment}
            title="Activité termite"
            onChange={this.props.onTermitesObservedChange}
            onChangeOther={this.props.onTermitesObservedCommentChange}
            readOnly={this.props.readOnly}
          />
          <RadioOptionWithComment
            name="ILXObserved"
            value={this.props.ILXObserved}
            valueOther={this.props.ILXObservedComment}
            title="Présence d''ILX"
            onChange={this.props.onILXObservedChange}
            onChangeOther={this.props.onILXObservedCommentChange}
            readOnly={this.props.readOnly}
          />
          <RadioOptionWithComment
            name="reinforceFramework"
            value={this.props.reinforceFramework}
            valueOther={this.props.reinforceFrameworkComment}
            title="Charpente à renforcer"
            onChange={this.props.onReinforceFrameworkChange}
            onChangeOther={this.props.onReinforceFrameworkCommentChange}
            readOnly={this.props.readOnly}
          />
        </Segment>

        <RadioOptionWithComment
          name="thermalInsulationProblem"
          value={this.props.thermalInsulationProblem}
          valueOther={this.props.thermalInsulationProblemComment}
          title="Problème au niveau de l'isolation"
          onChange={this.props.onThermalInsulationProblemChange}
          onChangeOther={this.props.onThermalInsulationProblemCommentChange}
          readOnly={this.props.readOnly}
        />
        <RadioOptionWithComment
          name="tileProblem"
          value={this.props.tileProblem}
          valueOther={this.props.tileProblemComment}
          title="Problème au niveau des tuiles"
          onChange={this.props.onTileProblemChange}
          onChangeOther={this.props.onTileProblemCommentChange}
          readOnly={this.props.readOnly}
        />
      </div>
    );
  }
}

StateOfPlay.propTypes = {
  accessible: PropTypes.bool,
  groundTypes: PropTypes.array.isRequired,
  groundTypeOther: PropTypes.string,
  moistureTrace: PropTypes.bool,
  moistureTraceComment: PropTypes.string,
  termiteInNeighbourhood: PropTypes.bool,
  termiteInNeighbourhoodComment: PropTypes.string,
  termiteTreatmentBefore: PropTypes.bool,
  termiteTreatmentBeforeComment: PropTypes.string,
  damagesObserved: PropTypes.bool,
  damagesObservedComment: PropTypes.string,
  termitesObserved: PropTypes.bool,
  termitesObservedComment: PropTypes.string,
  ILXObserved: PropTypes.bool,
  ILXObservedComment: PropTypes.string,
  reinforceFramework: PropTypes.bool,
  reinforceFrameworkComment: PropTypes.string,
  thermalInsulationProblem: PropTypes.bool,
  thermalInsulationProblemComment: PropTypes.string,
  tileProblem: PropTypes.bool,
  tileProblemComment: PropTypes.string,

  groundTypeRefs: PropTypes.array.isRequired,

  onAccessibleChange: PropTypes.func.isRequired,
  onMoistureTraceChange: PropTypes.func.isRequired,
  onMoistureTraceCommentChange: PropTypes.func.isRequired,
  onTermiteInNeighbourhoodChange: PropTypes.func.isRequired,
  onTermiteInNeighbourhoodCommentChange: PropTypes.func.isRequired,
  onTermiteTreatmentBeforeChange: PropTypes.func.isRequired,
  onTermiteTreatmentBeforeCommentChange: PropTypes.func.isRequired,
  onDamagesObservedChange: PropTypes.func.isRequired,
  onDamagesObservedCommentChange: PropTypes.func.isRequired,
  onTermitesObservedChange: PropTypes.func.isRequired,
  onTermitesObservedCommentChange: PropTypes.func.isRequired,
  onILXObservedChange: PropTypes.func.isRequired,
  onILXObservedCommentChange: PropTypes.func.isRequired,
  onReinforceFrameworkChange: PropTypes.func.isRequired,
  onReinforceFrameworkCommentChange: PropTypes.func.isRequired,
  onThermalInsulationProblemChange: PropTypes.func.isRequired,
  onThermalInsulationProblemCommentChange: PropTypes.func.isRequired,
  onTileProblemChange: PropTypes.func.isRequired,
  onTileProblemCommentChange: PropTypes.func.isRequired,
};

const mapStateToProps = (state, ownProps) => ({
  groundTypes: state.form.form.stateOfPlay.groundTypes,
  groundTypeOther: state.form.form.stateOfPlay.groundTypeOther,
  groundTypeRefs: state.requirements.soilTypes,
  accessible: state.form.form.framework.accessible,
  moistureTrace: state.form.form.stateOfPlay.moistureTrace,
  moistureTraceComment: state.form.form.stateOfPlay.moistureTraceComment,
  termiteInNeighbourhood: state.form.form.stateOfPlay.termiteInNeighbourhood,
  termiteInNeighbourhoodComment:
    state.form.form.stateOfPlay.termiteInNeighbourhoodComment,
  termiteTreatmentBefore: state.form.form.stateOfPlay.termiteTreatmentBefore,
  termiteTreatmentBeforeComment:
    state.form.form.stateOfPlay.termiteTreatmentBeforeComment,
  damagesObserved: state.form.form.framework.damagesObserved,
  damagesObservedComment: state.form.form.framework.damagesObservedComment,
  termitesObserved: state.form.form.framework.termitesObserved,
  termitesObservedComment: state.form.form.framework.termitesObservedComment,
  ILXObserved: state.form.form.framework.ILXObserved,
  ILXObservedComment: state.form.form.framework.ILXObservedComment,
  reinforceFramework: state.form.form.framework.reinforceFramework,
  reinforceFrameworkComment:
    state.form.form.framework.reinforceFrameworkComment,
  thermalInsulationProblem: state.form.form.framework.thermalInsulationProblem,
  thermalInsulationProblemComment:
    state.form.form.framework.thermalInsulationProblemComment,
  tileProblem: state.form.form.framework.tileProblem,
  tileProblemComment: state.form.form.framework.tileProblemComment,
});

const mapDispatchToProps = (dispatch, ownProps) => ({
  onAccessibleChange: (_, change) =>
    dispatch(updateData('framework.accessible', change.value)),
  onGroundTypesChange: (_, change) =>
    dispatch(updateData('stateOfPlay.groundTypes', change.value)),
  onGroundTypeOtherChange: (_, change) =>
    dispatch(updateData('stateOfPlay.groundTypeOther', change.value)),
  onMoistureTraceChange: (_, change) =>
    dispatch(updateData('stateOfPlay.moistureTrace', change.value)),
  onMoistureTraceCommentChange: (_, change) =>
    dispatch(updateData('stateOfPlay.moistureTraceComment', change.value)),
  onTermiteInNeighbourhoodChange: (_, change) =>
    dispatch(updateData('stateOfPlay.termiteInNeighbourhood', change.value)),
  onTermiteInNeighbourhoodCommentChange: (_, change) =>
    dispatch(
      updateData('stateOfPlay.termiteInNeighbourhoodComment', change.value)
    ),
  onTermiteTreatmentBeforeChange: (_, change) =>
    dispatch(updateData('stateOfPlay.termiteTreatmentBefore', change.value)),
  onTermiteTreatmentBeforeCommentChange: (_, change) =>
    dispatch(
      updateData('stateOfPlay.termiteTreatmentBeforeComment', change.value)
    ),
  onDamagesObservedChange: (_, change) =>
    dispatch(updateData('framework.damagesObserved', change.value)),
  onDamagesObservedCommentChange: (_, change) =>
    dispatch(updateData('framework.damagesObservedComment', change.value)),
  onTermitesObservedChange: (_, change) =>
    dispatch(updateData('framework.termitesObserved', change.value)),
  onTermitesObservedCommentChange: (_, change) =>
    dispatch(updateData('framework.termitesObservedComment', change.value)),
  onILXObservedChange: (_, change) =>
    dispatch(updateData('framework.ILXObserved', change.value)),
  onILXObservedCommentChange: (_, change) =>
    dispatch(updateData('framework.ILXObservedComment', change.value)),
  onReinforceFrameworkChange: (_, change) =>
    dispatch(updateData('framework.reinforceFramework', change.value)),
  onReinforceFrameworkCommentChange: (_, change) =>
    dispatch(updateData('framework.reinforceFrameworkComment', change.value)),
  onThermalInsulationProblemChange: (_, change) =>
    dispatch(updateData('framework.thermalInsulationProblem', change.value)),
  onThermalInsulationProblemCommentChange: (_, change) =>
    dispatch(
      updateData('framework.thermalInsulationProblemComment', change.value)
    ),
  onTileProblemChange: (_, change) =>
    dispatch(updateData('framework.tileProblem', change.value)),
  onTileProblemCommentChange: (_, change) =>
    dispatch(updateData('framework.tileProblemComment', change.value)),
});

export default connect(mapStateToProps, mapDispatchToProps)(StateOfPlay);



// WEBPACK FOOTER //
// ./src/modules/saas/aast/case-study/components/StateOfPlay.js